module.exports = __webpack_public_path__ + "static/media/15.07dfb9da.jpg";